import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const AUTH_HEADER_KEY = 'Authorization';
const AUTH_PREFIX = 'Bearer ';
const TOKEN_NAME = 'authToken';

@Injectable()
export class InterceptorHttpService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = `${AUTH_PREFIX}${sessionStorage.getItem(TOKEN_NAME)}`;
    req.headers.set(AUTH_HEADER_KEY, `${AUTH_PREFIX} ${token}`);
    return next.handle(req);
  }

  // TODO à refaire lorsque l'on réactivera l'interceptor du BACK d'orphe
  // public request(url: string | Request): Observable<Response> {
  //
  //   const token = sessionStorage.getItem(TOKEN_NAME);
  //
  //   const options = {headers: new Headers()};
  //   if (typeof url === 'string') {
  //
  //     options.headers.set(AUTH_HEADER_KEY, `${AUTH_PREFIX} ${token}`);
  //   } else {
  //     url.headers.set(AUTH_HEADER_KEY, `${AUTH_PREFIX} ${token}`);
  //   }
  //   return super.request(url, options).catch(this.catchError);
  // }
  //
  // public get(url: string, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.get(url, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public post(url: string, body: any, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.post(url, body, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public put(url: string, body: any, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.put(url, body, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public delete(url: string, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.delete(url, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public patch(url: string, body: any, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.patch(url, body, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public head(url: string, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.head(url, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // public options(url: string, options?): Observable<Response> {
  //   const enhacedOptions = this.setAuthorizationHeader(options);
  //   return super.options(url, enhacedOptions).pipe(catchError(this.catchError));
  // }
  //
  // // Ajout de l'attribut Authorization au Header
  // private setAuthorizationHeader(options?) {
  //
  //   const token = `${AUTH_PREFIX}${sessionStorage.getItem(TOKEN_NAME)}`;
  //   // Copie du header dans le RequestOptions et ajout du token a 'Authorization'
  //   const headers = {
  //     ...options.headers.toJSON(),
  //     Authorization: token
  //   };
  //   options.headers = new Headers(headers);
  //   return options;
  // }
  //
  // // Response Interceptor
  // private catchError(error: any): Observable<any> {
  //
  //   if (error instanceof HttpErrorResponse) {
  //     return Observable.throw(error);
  //   } else if (error instanceof Response) {
  //     if (sessionStorage.getItem('loginFlag') === 'true' && error.status === 401) {
  //       sessionStorage.removeItem(TOKEN_NAME);
  //       sessionStorage.removeItem('loginFlag');
  //       window.location.reload();
  //     }
  //     return Observable.throw(error);
  //   } else {
  //     return Observable.throw(error);
  //   }
  // }
}

